import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import {GenericMethod} from '@/core/Types/IRepository';

class TableServices extends BaseRepository {
  public collection = 'tables';
  public version = 'v2';

  public getActiveTables(params: GenericMethod) {
    return this.request({...params, url: 'get_active_tables_by_zone'});
  }

  public getTableStyles(params: GenericMethod) {
    return this.request({...params, method: 'GET', url: 'table_styles'});
  }

  public createTableStyles(params: GenericMethod) {
    return this.request({...params, method: 'POST', url: 'table_styles'});
  }

  public updateTableStyles(params: GenericMethod) {
    return this.request({...params, method: 'PUT', url: 'table_styles'});
  }

  public deleteAllStyles(params: GenericMethod) {
    return this.request({...params, method: 'POST', url: 'table_styles/delete_all_styles'});
  }

  public deleteTableStyles(params) {
    return this.request({...params, method: 'DELETE', url: 'table_styles'});
  }

  public async getTablesListByLocal(params: GenericMethod) {
    return this.request({...params, url: 'list_bar'});
  }
}

export default new TableServices(axiosInstance);
